// /components/GTM.jsx
import Script from "next/script";

/**
 * Google Tag Manager bootstrap + Consent‑Mode defaults.
 * Include exactly once, as early as possible (beforeInteractive).
 */
export default function GTM() {
  const GTM_ID = "GTM-KXZRG4LK";   // ← your container ID
  return (
    <>
      {/* Main GTM snippet + Consent defaults (all denied) */}
      <Script
        id="gtm-init"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `
            (function(w,d,s,l,i){w[l]=w[l]||[];
               w[l].push({'gtm.start': new Date().getTime(), event:'gtm.js'});
               var f=d.getElementsByTagName(s)[0],
               j=d.createElement(s), dl=l!='dataLayer'?'&l='+l:'';
               j.async=true; j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;
               f.parentNode.insertBefore(j,f);
            })(window,document,'script','dataLayer','${GTM_ID}');

            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('consent','default',{
              ad_storage:'denied',
              analytics_storage:'denied',
              ad_user_data:'denied',
              ad_personalization:'denied'
            });
            gtag('set','url_passthrough',true);
            gtag('set','ads_data_redaction',true);
          `,
        }}
      />

      {/* noscript fallback (required for GTM) */}
      <noscript>
        <iframe
          src={`https://www.googletagmanager.com/ns.html?id=${GTM_ID}`}
          height="0"
          width="0"
          style={{ display: "none", visibility: "hidden" }}
        />
      </noscript>
    </>
  );
}
